import React from 'react';
import {connect} from 'react-redux';
import {Nav, NavItem} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {fetchStructure, fetchPublication} from './../../structures/actions';
import {FormattedMessage} from 'react-intl';
import {diaBase, articleRoute, publicationRoute, annotationFromStructure} from '../../../constants/public-routes';
import Link from '../../routing/components/Link';

import printModule from '../../print';
import {getIdFromRelation} from "../../app/selectors";
let {PrintButtons} = printModule.components;

class LawContainer extends React.Component {
  constructor(props) {
    super(props);
    this.getStructure = this.getStructure.bind(this);
    this.getRelatedArticles = this.getRelatedArticles.bind(this);

  }

  componentDidMount() {
    let {params, structure, dispatch} = this.props;
    this.getStructure(params, structure, dispatch);
  }

  componentWillReceiveProps(nextProps) {
    let {params, structure, dispatch} = nextProps;
    this.getStructure(params, structure, dispatch);
  }

  getStructure(params, structure, dispatch) {
    if (params.structureId && params.structureId !== structure.item.id) {
      if (!structure.isFetching) {
        dispatch(fetchStructure(params.structureId));
      }
    } else if (params.publicationId) {
      let publicationId = getIdFromRelation(structure.item, 'publication');
      if (params.publicationId !== publicationId) {
        if (!structure.isFetching) {
          dispatch(fetchPublication(params.publicationId, params.lang));
        }
      }
    }
  }

  getRelatedArticles() {
    let {params, article, structure} = this.props;

    let result = {
      previous: null,
      next: null
    };

    if (!params.articleId || !article.item.attributes.canonical_element || !structure.item.attributes.flatToc) {
      return result;
    }

    let found = false;
    structure.item.attributes.flatToc.forEach(elem => {
      if (elem.type !== 'article') {
        return;
      }
      if (!found) {
        if (elem.canonical === article.item.attributes.canonical_element) {
          found = true;
        } else {
          result.previous = elem;
        }
      } else {
        if (!result.next) {
          result.next = elem;
        }
      }
    });

    return result;
  }

  render() {
    let {getRelatedArticles} = this;
    const {element, structure, article, params, children, intl, elementAnnotations} = this.props;
    let header;
    let title = "";

    let url = diaBase(intl.locale);

    if (params.structureId) {
      url += '/structure/' + params.structureId;
    } else if (params.publicationId) {
      url += '/' + params.date + '/publication/' + params.publicationId;
    }

    if (params.articleId) {
      url += '/article/' + params.articleId;
    } else if (params.conceptId) {
      url += '/concept/' + params.conceptId;
    }

    if (params.elementId) {
      url += '/element/' + params.elementId;
    }


    if (params.elementId && element.item.attributes) {
      title = element.item.attributes.label;
      let annotationIds = [];
      if (params.annotationId) {
        annotationIds = [params.annotationId];
      }
      else if (elementAnnotations.item) {
        annotationIds = elementAnnotations.item.map(function (annotation) {
          return annotation.id;
        });
      }
      annotationIds.unshift(element.item.id);

      // TODO should be annotation type instead of generic 'annotationOf'
      header = (
        <div>
          <h1 className="page-title">
            <FormattedMessage id={params.annotationId ? "annotationOf" : "annotationsOf"}/> <Link url={articleRoute(article.item.id, params)}>{title}</Link>
            {params.annotationId ?
              (<small className="page-title-link">&nbsp;(<Link url={annotationFromStructure(params, params.elementId)}><FormattedMessage id="annotationsBack"/></Link>)</small>) : null
            }
            {params.annotationId ?
              (<PrintButtons style={{fontSize: "0.5em"}} ids={[params.elementId, params.annotationId]}
                            label={intl.messages.annotation + ' - ' + title + ' (' + article.item.attributes.label_structure + ')'}/>) :
              (<PrintButtons style={{fontSize: "0.5em"}} ids={annotationIds}
                            label={intl.messages.annotations + ' - ' + title + ' (' + article.item.attributes.label_structure + ')'}
                            disabled={!elementAnnotations.item}/>)
            }
            <br/>
            <small><FormattedMessage id="from"/>: <Link
              url={publicationRoute(params)}>{article.item.attributes.label_structure || <FormattedMessage id="noStructureLabel"/>}</Link></small>
          </h1>
          {/*<div style={{maxHeight: 300, overflowX: 'auto'}} dangerouslySetInnerHTML={{__html: article.item.attributes.body}}/>*/}
          {/*<PreviewText animation="1.2s ease" collapseText={<span><FormattedMessage id="showLess"/>&nbsp;<span className="fa-stack"><span*/}
          {/*className="fa fa-angle-up fa-stack-1x"></span><span className="fa fa-circle-o fa-stack-1x"></span></span></span>}*/}
          {/*expandText={<span><FormattedMessage id="showMore"/>&nbsp;<span className="fa-stack"><span*/}
          {/*className="fa fa-angle-down fa-stack-1x"></span><span className="fa fa-circle-o fa-stack-1x"></span></span></span>} minHeight="100px">*/}
          {/*<div dangerouslySetInnerHTML={{__html: article.item.attributes.body}}/>*/}
          {/*</PreviewText>*/}
          {/*<div className="articlePreview" dangerouslySetInnerHTML={{__html: article.item.attributes.body}}/>*/}
          {/*<Panel bsStyle="primary">
           <Nav bsStyle="tabs" className="nav-primary">
           <LinkContainer to={url + '/annotation'}>
           <NavItem eventKey={3}><FormattedMessage id={'annotations'}/></NavItem>
           </LinkContainer>
           <LinkContainer to={url + '/elementabout'}>
           <NavItem eventKey={1}><FormattedMessage id={'aboutThisText'}/></NavItem>
           </LinkContainer>
           <LinkContainer to={url + '/elementlanguages'}>
           <NavItem eventKey={3}><FormattedMessage id={'differentLanguages'}/></NavItem>
           </LinkContainer>
           </Nav>
           </Panel>*/}
        </div>
      );
    } else if ((params.articleId || params.conceptId) && article.item.attributes) {
      title = article.item.attributes.label;
      let relatedArticles = getRelatedArticles();
      header = (
        <div>
          <h1>{title}
            <PrintButtons style={{fontSize: "0.5em"}} ids={[params.articleId]} label={title + ' (' + article.item.attributes.label_structure + ')'}/>
            <br/>
            <small><FormattedMessage id="from"/>: <Link url={publicationRoute(params)}>{article.item.attributes.label_structure ||
            <FormattedMessage id="noStructureLabel"/>}</Link></small>
          </h1>
          <Nav bsStyle="tabs" className="nav-primary">
            <LinkContainer to={url + '/articletext'}>
              <NavItem eventKey={3}><FormattedMessage id={'text'}/></NavItem>
            </LinkContainer>
            {/*<LinkContainer to={url + '/articleabout'}>*/}
            {/*<NavItem eventKey={1}><FormattedMessage id={'aboutThisText'}/></NavItem>*/}
            {/*</LinkContainer>*/}
            <LinkContainer to={url + '/articleversions'}>
              <NavItem eventKey={3}><FormattedMessage id={'otherVersions'}/></NavItem>
            </LinkContainer>
            <LinkContainer to={url + '/articlelanguages'}>
              <NavItem eventKey={3}><FormattedMessage id={'differentLanguages'}/></NavItem>
            </LinkContainer>
            {relatedArticles.next ? (<LinkContainer to={articleRoute(relatedArticles.next.article_id, params)}>
              <NavItem className="pull-right" eventKey={3}><FormattedMessage id="next"/>:&nbsp;{relatedArticles.next.label}&nbsp;<i
                className="glyphicon glyphicon-chevron-right"/></NavItem>
            </LinkContainer>) : (
              <NavItem className="pull-right disabled" eventKey={3}><FormattedMessage id="next"/>:&nbsp;<em><FormattedMessage id="lastArticle"/></em>&nbsp;<i
                className="glyphicon glyphicon-chevron-right"/></NavItem>)}
            {relatedArticles.previous ? (<LinkContainer to={articleRoute(relatedArticles.previous.article_id, params)}>
              <NavItem className="pull-right" eventKey={3}><i className="glyphicon glyphicon-chevron-left"/>&nbsp;<FormattedMessage
                id="previous"/>:&nbsp;{relatedArticles.previous.label}</NavItem>
            </LinkContainer>) : (
              <NavItem className="pull-right disabled" eventKey={3}><i className="glyphicon glyphicon-chevron-left"/>&nbsp;<FormattedMessage
                id="previous"/>:&nbsp;<em><FormattedMessage id="firstArticle"/></em></NavItem>)}
          </Nav>
        </div>
      );
    } else if ((params.structureId || params.publicationId) && structure.item.attributes) {
      title = structure.item.attributes.label;
      let articleIds = [];
      if (structure.item.attributes.flatToc) {
        structure.item.attributes.flatToc.forEach((toc) => {
          if (toc.article_id) {
            articleIds.push(toc.article_id);
          }
          else {
            articleIds.push(toc.id);
          }
        });
      }
      else {
        articleIds.unshift(params.structureId);
      }
      header = (
        <div>
          <h1>{title || <FormattedMessage id="noStructureLabel"/>}
            <PrintButtons style={{fontSize: "0.5em"}} ids={articleIds} label={title} disabled={!structure.item.attributes.flatToc}/>
          </h1>
          <Nav bsStyle="tabs" className="nav-primary">
            <LinkContainer to={url + '/toc'}>
              <NavItem eventKey={3}><FormattedMessage id={'tableOfContents'}/></NavItem>
            </LinkContainer>
            <LinkContainer to={url + '/about'}>
              <NavItem eventKey={1}><FormattedMessage id={'aboutThisText'}/></NavItem>
            </LinkContainer>
            <LinkContainer to={url + '/versions'}>
              <NavItem eventKey={3}><FormattedMessage id={'otherVersions'}/></NavItem>
            </LinkContainer>
            <LinkContainer to={url + '/languages'}>
              <NavItem eventKey={3}><FormattedMessage id={'differentLanguages'}/></NavItem>
            </LinkContainer>
          </Nav>
        </div>
      );

    }
    return (
      <div>
        {header}
        <div className="subdiv">
          {children}
        </div>
      </div>
    );
  }
}

LawContainer.propTypes = {
  children: React.PropTypes.node,
  params: React.PropTypes.object.isRequired,
  structure: React.PropTypes.object.isRequired,
  article: React.PropTypes.object.isRequired,
  element: React.PropTypes.object.isRequired,
  elementAnnotations: React.PropTypes.object.isRequired,
  intl: React.PropTypes.object.isRequired,
  dispatch: React.PropTypes.func.isRequired
};


function mapStateToProps(state) {
  const {structure, article, element, intl, elementAnnotations} = state;

  return {
    structure,
    article,
    element,
    elementAnnotations,
    intl
  };
}

export default connect(mapStateToProps)(LawContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/laws/containers/LawContainer.js
 **/